import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Header2 from "../../components/header/Header2";
import Category14 from "../../components/category/Category14";
import Category08 from "../../components/category/Category08";
import Category09 from "../../components/category/Category09";
import Category07 from "../../components/category/Category07";
import ReviewJob from "../../components/jobs/ReviewJob";
import Partner from "../../components/partner";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import { Link } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../../assets/siteimages/logo.png";
import styles from "../../assets/Home.module.css";
import axios from "axios";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Testimonials from "../../components/testimonials";
import Blog01 from "../../components/blog/Blog01";
import Contact from "../../components/contact";
import { Helmet } from "react-helmet-async";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa"; // Import icons
import "../../assets/Loader.css";
import BannerCounter from "../../components/aboutPage/BannerCounter";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";


Home.propTypes = {};

function Home(props) {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({
      live: false,
    });
    window.wow.init();
  }, []);

  const [categories, setCategories] = useState([]);
  const [categoriesnew, setCategoriesnew] = useState([]);
  const [categoriesnew1, setCategoriesnew1] = useState([]);
   const [categoriesnew2, setCategoriesnew2] = useState([]);
    const [data, setData] = useState([]);
     const [sliders, setSliders] = useState([]);

  useEffect(() => {
    fetchCategories();
    fetchCategoriesnew();
    fetchCategoriesnew1();
     fetchCategoriesnew2();
      fetchCategoriesnew3();
       fetch1();
  }, []);

     const fetch1 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/epoojasliders"); // Adjust the URL if needed
      setSliders(response.data);
    } catch (error) {
      console.error("Error course categories:", error);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/blogcategoriessort"); // Adjust the URL if needed
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching blog categories:", error);
    }
  };

  const fetchCategoriesnew = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/horoscopecategoriessort"); // Adjust the URL if needed
      setCategoriesnew(response.data);
    } catch (error) {
      console.error("Error fetching horoscope categories:", error);
    }
  };

  const fetchCategoriesnew1 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrocategoriessort"); // Adjust the URL if needed
      setCategoriesnew1(response.data);
    } catch (error) {
      console.error("Error fetching astro categories:", error);
    }
  };

   const fetchCategoriesnew2 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/coursecategoriessort"); // Adjust the URL if needed
      setCategoriesnew2(response.data);
    } catch (error) {
      console.error("Error course categories:", error);
    }
  };

   const fetchCategoriesnew3 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/coursessort"); // Adjust the URL if needed
      setData(response.data);
    } catch (error) {
      console.error("Error course categories:", error);
    }
  };

  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/primarybannerssort")
      .then(response => {
        setImages(response.data);
        setLoading(false); // Hide loader after data is fetched
      })
      .catch(error => {
        console.error("Error fetching images:", error);
        setLoading(false); // Also hide loader on error
      });
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
  };

const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const [reviewsMap, setReviewsMap] = useState({});

  useEffect(() => {
  const fetchApprovedReviews = async () => {
    try {
      const res = await axios.get(
        "https://adhigyanam-e92bf1bbbdb1.herokuapp.com/reviews-approved-courses"
      );

      const map = {};

      res.data.forEach((r) => {
        map[Number(r.CourseId)] = {
          avg: r.avgRating,
          count: r.totalReviews
        };
      });

      setReviewsMap(map);
    } catch (err) {
      console.error("Error fetching course reviews:", err);
    }
  };

  fetchApprovedReviews();
}, []);

const renderStars = (rating) => {
  return (
    <div style={{ display: "flex", gap: "2px" }}>
      {[1,2,3,4,5].map((num) => (
        <span
          key={num}
          style={{
            color: num <= Math.round(rating) ? "#ffc107" : "#ddd",
            fontSize: "14px"
          }}
        >
          ★
        </span>
      ))}
    </div>
  );
};

 
  return (
    <>
    <Helmet>
        <title>Home - Adhigyanam | Sauntesthyam LLP</title>
      </Helmet>
      <div className="menu-mobile-popup">
        <div className="modal-menu__backdrop" onClick={handleMobile}></div>
        <div className="widget-filter">
          <div className="mobile-header">
            <div id="logo" className="logo">
              <Link to="/home">
                <img className="site-logo" src={logo} alt="Image" />
              </Link>
            </div>
            <Link className="title-button-group" onClick={handleMobile}>
              <i className="icon-close"></i>
            </Link>
          </div>

         <Tabs className="tf-tab">
            

            <div className="content-tab">
              <TabPanel className="header-ct-center menu-moblie animation-tab">
                <div className="nav-wrap">
                  <nav className="main-nav mobile">
                    <ul id="menu-primary-menu" className="menu">
                    <li className="menu-item ">
                        <Link
                          to="/home"
                          className="iteam-menu"
                          
                        >
                          Home
                        </Link>
                      </li>
                      {/* <li className="menu-item ">
                        <Link
                          to="/about"
                          className="iteam-menu"
                          
                        >
                          About Us
                        </Link>
                      </li> */}

                   

                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("services");
                          }}
                        >
                          eConsultation
                        </Link>
                        <Collapse isOpened={toggle.key === "services"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "services" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew1.length > 0 ? (
          categoriesnew1.map((categorynew1, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/category-details/${categorynew1.Id}`}>{categorynew1.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                     
                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("courses");
                          }}
                        >
                          eLearning
                        </Link>
                        <Collapse isOpened={toggle.key === "courses"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "courses" ? "block" : "none"
                              }`,
                            }}
                          >
                           {categoriesnew2.length > 0 ? (
          categoriesnew2.map((categoriesnew2, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/course-category-details/${categoriesnew2.Id}`}>{categoriesnew2.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}
                            
                          </ul>
                        </Collapse>
                      </li>
                    <li className="menu-item ">
                        <Link
                          to="/epooja"
                          className="iteam-menu"
                          
                        >
                          ePooja
                        </Link>
                      </li>
                     
                         <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("horoscope");
                          }}
                        >
                         Horoscope
                        </Link>
                        <Collapse isOpened={toggle.key === "horoscope"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "horoscope" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew.length > 0 ? (
          categoriesnew.map((categorynew, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/horoscopes/${categorynew.Id}`}>{categorynew.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                       <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("blog");
                          }}
                        >
                          Blog
                        </Link>
                        <Collapse isOpened={toggle.key === "blog"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "blog" ? "block" : "none"
                              }`,
                            }}
                          >

 {categories.length > 0 ? (
          categories.map((categories, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/blog-category-details/${categories.Id}`}>{categories.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                      <li className="menu-item ">
                        <Link
                          to="/support"
                          className="iteam-menu"
                          
                        >
                         FAQ & Support
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </TabPanel>

           
            </div>
          </Tabs>
          <div className="header-customize-item button" style={{padding: "0px 0px",
    background:"none",
    backgroundColor:"#14a077",
    borderRadius: "4px",
    fontWeight: "700",
    fontSize: "16px",
    lineHeight: "26px",
    color: "white",
    borderColor: "transparent",
    textTransform: "capitalize"}}>
            <Link to="/astroservices" style={{color: "#ffffff"}}>Consult Now</Link>
          </div>
          <div className="header-customize-item button">
            <Link to="/login">My Account</Link>
          </div>

          <div className="mobile-footer">
            <div className="icon-infor d-flex aln-center">
              <div className="icon">
                <span className="icon-call-calling">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                </span>
              </div>
              <div className="content">
                <p>Need help? 24/7</p>
                <h6>
                   <Link to={`tel:918960708425`}>+91-8960708425</Link>
                </h6>
              </div>
            </div>
            <p><b>Corporate Address</b>: Sauntesthyam LLP, Munshi Puliya, Indira Nagar, Lucknow, Uttar Pradesh - 226016</p>
            <p style={{marginTop:"15px"}}><b>Write To Us On</b>: <Link to={`mailto:sauntesthyam@gmail.com`} style={{textDecoration:"underline"}}>sauntesthyam@gmail.com</Link>, <Link to={`mailto:info@adhigyanam.com`}  style={{textDecoration:"underline"}}>info@adhigyanam.com</Link></p>
            <div className="wd-social d-flex aln-center" style={{marginTop:"15px"}}>
      <ul className="list-social d-flex aln-center">
                                     <li><Link to="https://www.facebook.com/Adhigyanam"><i className="icon-facebook"></i></Link></li>
                                     <li><Link to="https://www.instagram.com/the_vedic_astro"><i className="icon-instagram1"></i></Link></li>
                                     <li><Link to="https://x.com/adhigyanam"><i className="icon-twitter"></i></Link></li>
                                 </ul>
    </div>
          </div>
        </div>
      </div>
     
       {/* <div className={styles.offerStrip}>
  🚀 Beta Launch! We are live and growing 🌱. However some features may be limited.💡
</div>  */}
      <Header2 clname="act1" handleMobile={handleMobile} />
       
      <div className="slider-container" style={{ width: "100%", margin: "auto", position: "relative", marginBottom:"10px" }}>
  {loading ? (
    <div className="loader">
      <div className="spinner"></div>
    </div>
  ) : (
  <Slider {...settings}>
  {images.map((image, index) => (
    <div key={index}>
      {image.Rurl && image.Rurl.trim() !== "" ? (
        <a
          href={image.Rurl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={image.Path1 || "default-image.jpg"}
            alt={`Slide ${index + 1}`}
            style={{
              width: "100%",
              height: "auto",
              borderRadius: "0px",
              cursor: "pointer",
            }}
          />
        </a>
      ) : (
        <img
          src={image.Path1 || "default-image.jpg"}
          alt={`Slide ${index + 1}`}
          style={{
            width: "100%",
            height: "auto",
            borderRadius: "0px",
          }}
        />
      )}
    </div>
  ))}
</Slider>
  )}
</div>

      <Category14 />
      <Partner />
            <section className="testimonials-category-section" style={{ paddingTop: "0px", paddingBottom:"20px" }}>
          <div className="tf-container">
    
         
    
            <div className="row">

           <div className="col-md-12">
            <div className="tf-title style-2" style={{marginBottom:"20px"}}>
              <div className="group-title">
                <h1  style={{ marginBottom: "0px", fontSize:"30px" }}>Master The Art Of Astrology</h1>
                <p>
                  Trusted Expert Courses in Vedic and Modern Astrology<br/>
                                  <Link to="/allcourses" style={{color: "#14a077",
                                        textTransform: "none", 
                                        border: "none", 
                                        fontWeight: "600",
                                        fontSize: "14px", 
                                        lineHeight: "22px"}}>Show All Courses</Link> |  <Link to="/coursecategories" style={{color: "#14a077",
                                        textTransform: "none", 
                                        border: "none", 
                                        fontWeight: "600",
                                        fontSize: "14px", 
                                        lineHeight: "22px"}}>Explore By Category</Link>
                </p>
              </div>
            </div>
          </div>
    
              <div className="col-md-12">
                <div className="row">
                 {data.map((item, index) => {
  const reviewData = reviewsMap[Number(item.Id)];

  return (
    <div key={index} className="col-lg-3 col-md-4 col-12">
      <div
        className="group-category-job padding wow fadeInUp"
        style={{ paddingBottom: "10px", marginTop: "5px" }}
      >
        <Link to={`/course/${item.Id}`}>
          <div className="job-category-box" style={{ width: "unset", padding: "18px" }}>
            <div className="job-category-header" style={{ marginBottom: "0px" }}>

              {/* Image */}
              <img
                src={item.Path1 || "default-image.jpg"}
                alt={item.Title}
                style={{ width: "100%", height: "auto", borderRadius: "10px" }}
              />

              {/* Category */}
              <Link
                to={`/courses/${item.Csid}`}
                style={{
                  display: "inline-block",
                  padding: "4px 12px",
                  background: "rgba(41, 100, 225, 0.1)",
                  borderRadius: "40px",
                  color: "#14a077",
                  fontSize: "12px",
                  lineHeight: "16px",
                  fontWeight: "500",
                  cursor: "pointer",
                  marginTop: "15px"
                }}
              >
                {item.Csname}
              </Link>

              {/* Title */}
              <h1
                style={{
                  marginTop: "15px",
                  fontWeight: "600",
                  fontSize: "16px",
                  marginBottom: "0px"
                }}
              >
                <Link to={`/course/${item.Id}`}>{item.Title}</Link>
              </h1>

              {/* ⭐ Ratings */}
              {reviewData ? (
                <div style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "8px" }}>
                  {renderStars(reviewData.avg)}
                  <span style={{ fontSize: "12px", color: "#6b7280" }}>
                    ({reviewData.avg}) • {reviewData.count} review(s)
                  </span>
                </div>
              ) : (
                <span
                  style={{
                    fontSize: "12px",
                    color: "#9ca3af",
                    display: "block",
                    marginBottom: "8px"
                  }}
                >
                  New Course
                </span>
              )}

              {/* Description */}
              <p style={{ marginBottom: "10px" }}>{item.Qdesc}</p>

              {/* Price */}
              <p>
                <b>Course Fee</b>: {item.Price1} INR -{" "}
                <b>Validity</b>: {item.Validity} Days
              </p>

            </div>

            {/* Button */}
            <Link to={`/course/${item.Id}`} className="btn-category-job" style={{ marginTop: "5px" }}>
              View Details
              <span className="icon-keyboard_arrow_right"></span>
            </Link>

          </div>
        </Link>
      </div>
    </div>
  );
})}
                </div>
                
              </div>
            </div>
          </div>
        </section>
      <ReviewJob />

      {/* <Category07 /> */}
      <Category08 />
  
      <Testimonials className="testimonials-section" />
           <section style={{ padding: "40px 0", paddingTop:"0px" }}>
  <div className="tf-container">

    <div className="row">
           <div className="col-md-12">
            <div className="tf-title style-2 style-4">
              <div className="group-title">
                <h1 style={{ fontSize: "30px", marginBottom: "0px" }}>ePooja Ritual Guides</h1>
<p>
Explore authentic Vedic pooja preparations, step-by-step rituals, and spiritual practices prepared by our pooja experts.
</p>
              </div>
            </div>
          </div>
          </div>

    <Swiper
      modules={[Pagination, Autoplay]}
      spaceBetween={20}
      slidesPerView={1}
      pagination={{ clickable: true }}
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      loop={true}
      breakpoints={{
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 }
      }}
    >

      {sliders.map((item, index) => (
        <SwiperSlide key={index}>
          <div className="wow fadeInUp">

            <Link to={item.Rurl || "#"}>
              <img
                src={item.Path1}
                alt="epooja"
                style={{
                  width: "100%",
                  height: "220px",
                  objectFit: "cover",
                  borderRadius: "12px",
                  boxShadow: "0 6px 16px rgba(0,0,0,0.12)"
                }}
              />
            </Link>

          </div>
        </SwiperSlide>
      ))}

    </Swiper>

  </div>
</section>
      <Blog01 className="news-section" />
      <Category09 />
      
      <BannerCounter />
      <Contact />

     
     

       <div
                 className="floating-buttons"
                 style={{
                   position: "fixed",
                   bottom: "20px",
                   left: "20px",
                   zIndex: "1000",
                   display: "flex",
                   flexDirection: "column",
                   gap: "10px",
                 }}
               >
                 {/* Call Button */}
                 <a
                   href={`tel:+918960708425`}
                   style={{
                     display: "flex",
                     alignItems: "center",
                     justifyContent: "center",
                     width: "60px",
                     height: "60px",
                     backgroundColor: "#007BFF",
                     borderRadius: "50%",
                     boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                     color: "white",
                     fontSize: "28px",
                   }}
                 >
                   <FaPhoneAlt />
                 </a>
               
                 {/* WhatsApp Button */}
                 <a
                   href={`https://wa.me/918960708425`}
                   target="_blank"
                   rel="noopener noreferrer"
                   style={{
                     display: "flex",
                     alignItems: "center",
                     justifyContent: "center",
                     width: "60px",
                     height: "60px",
                     backgroundColor: "#25D366",
                     borderRadius: "50%",
                     boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                     color: "white",
                     fontSize: "28px",
                   }}
                 >
                   <FaWhatsapp />
                 </a>
               </div>
      <Footer />
      <Gotop />
    </>
  );
}
// Custom left arrow
const CustomPrevArrow = (props) => {
  const { onClick } = props;
  return (
    <FaChevronLeft 
      className="custom-arrow custom-prev-arrow"
      onClick={onClick}
      style={{
        position: "absolute",
        left: "10px",
        top: "50%",
        transform: "translateY(-50%)",
        fontSize: "30px",
        color: "#fff",
        cursor: "pointer",
        zIndex: 1000,
        background: "rgba(0,0,0,0.5)",
        borderRadius: "50%",
        padding: "5px",
      }}
    />
  );
};

// Custom right arrow
const CustomNextArrow = (props) => {
  const { onClick } = props;
  return (
    <FaChevronRight 
      className="custom-arrow custom-next-arrow"
      onClick={onClick}
      style={{
        position: "absolute",
        right: "10px",
        top: "50%",
        transform: "translateY(-50%)",
        fontSize: "30px",
        color: "#fff",
        cursor: "pointer",
        zIndex: 1000,
        background: "rgba(0,0,0,0.5)",
        borderRadius: "50%",
        padding: "5px",
      }}
    />
  );
};
export default Home;
